export default __webpack_public_path__ + "static/media/DeletingTokens.994008cb.mp4";